// Source: https://play.tailwindcss.com/QUJkQyyWCt?size=694x720&file=css

const DIALOG = {
  ".dialog::backdrop": { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  ".dialog[open]": {
    "@apply ds-fixed ds-box-border ds-flex ds-h-[90vh] ds-min-w-[90%] ds-flex-col ds-items-center ds-justify-center ds-gap-[28px] ds-border ds-border-tertiary-lightgrey ds-px-[21px] ds-py-[50px] sm:ds-min-w-[554px] sm:ds-h-fit": true,
  },
  ".dialog .close::before": {
    fontFamily: '"Vattenfall Elements Icons"',
    content: '"\\e980"',
  },
  ".dialog .close": {
    "@apply ds-absolute ds-right-lg ds-top ds-cursor-pointer ds-text-xl": true,
  },
  ".dialog > header": {
    "@apply ds-mb-[12px] ds-text-center ds-leading-xl ds-text-4xl md:ds-text-5xl": true,
  },
  ".dialog > *:not(header, footer)": {
    "@apply ds-max-w-[375px] ds-text-center ds-text-base md:ds-text-lg": true,
  },

  ".dialog > footer, .dialog > footer > *": {
    "@apply ds-flex ds-w-full ds-max-w-[375px] ds-flex-row ds-justify-center ds-gap-[28px] ds-text-center ds-leading-base md:ds-gap-[20px]": true,
  },
};

// TODO (stefan): Make this global
// When exporting a Tailwind CSS to JavaScript using this tool: https://transform.tools/css-to-js
// we also need to remove the prefix (ds) before we can use it inside our config.
// This utility function solves that problem.
// We might consider turning this into a global utility if we want to use it in more components
// in the future.
const parseKeys = (source) => {
  const target = {};
  for (const sourceKey in source)
    if (typeof source[sourceKey] === "object") {
      const targetKey = sourceKey.replace(/\.ds-/g, ".").replace(/\n/, "");
      target[targetKey] = parseKeys(source[sourceKey]);
    } else target[sourceKey] = source[sourceKey];
  return target;
};

module.exports = () => parseKeys(DIALOG);
